import { render } from "./BGFLogo.vue?vue&type=template&id=f75b061e&scoped=true"
import script from "./BGFLogo.vue?vue&type=script&lang=js"
export * from "./BGFLogo.vue?vue&type=script&lang=js"

import "./BGFLogo.vue?vue&type=style&index=0&id=f75b061e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f75b061e"]])

export default __exports__